import {createAction, createAsyncThunk} from '@reduxjs/toolkit';
import getReviewTags from 'api/facilities/get-review-tags';
import {type ReviewTagsResults} from 'api/facilities/review-tags.types';
import {type MultiselectOption} from 'common/multiselect';

interface Period {
    value: number;
    unit: string;
}
interface GetReviewTagsParams {
    facilityId: number;
    selectedPeriodObject: Period;
    selectedReservationTypes: MultiselectOption[];
}

/**
 * Fetches the review tags data for a given facility.
 *
 * This thunk action creator makes an asynchronous call to the API to retrieve
 * the review tags data for the specified facility and period.
 *
 * Action Type: 'facilities/getReviewTagsData'
 *
 * API Service: {@link getReviewTags}
 */
export const getReviewTagsData = createAsyncThunk<
    ReviewTagsResults,
    GetReviewTagsParams
>(
    'facilities/getReviewTagsData',
    async (
        {facilityId, selectedPeriodObject, selectedReservationTypes},
        {rejectWithValue}
    ) => {
        try {
            const reservationTypes = selectedReservationTypes.map(
                (option) => option.value
            );

            const response: ReviewTagsResults = await getReviewTags(
                facilityId,
                selectedPeriodObject,
                reservationTypes
            );

            return response;
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

/**
 * Action to handle the state of the reservations filters
 */
export const setReviewTagsReservationTypes = createAction<MultiselectOption[]>(
    'facilities/setReviewTagsReservationTypes'
);

/**
 * Action to handle the state of the reservations filters
 */
export const setReviewTagsPeriod = createAction<string>(
    'facilities/setReviewTagsPeriod'
);
